document.addEventListener('DOMContentLoaded', function() {
    // Tabs functionalities
    const container = document.querySelector('[js-collection-tabs-container]')
    const tabs = container.querySelectorAll('[js-collection-tabs]')
    const tabContents = container.querySelectorAll('[js-tab-contents]')

    tabs.forEach((tab) => {
        tab.addEventListener('click', function({currentTarget}) {

            if(currentTarget.classList.contains('active')) return
            if(currentTarget) {
                tabs.forEach(tab => tab.classList.contains('active') ? tab.classList.remove('active') : "")
                tabContents.forEach(content =>  !content.classList.contains('hide') ? content.classList.add('hide') : "")
                currentTarget.classList.add('active')
                const currentTabIndex = currentTarget.dataset.tabIndex
                const currentTabContent = container.querySelector(`[js-tab-contents]#content-${currentTabIndex}`)
                
                currentTabContent.classList.contains('hide') ? currentTabContent.classList.remove('hide') : ""

            }
        })
    })

    // init
    tabs[0].click()


    // Color Swatch Functionalities
    const colorSwatchItems = container.querySelectorAll('[js-color-swatch-item]')

    colorSwatchItems.forEach(item => {
        item.addEventListener('click', function({currentTarget}) {
            if(currentTarget.classList.contains('active')) return

            // top element to climb and look
            const parent = currentTarget.closest('[js-tab-contents]')
            const imageElm =  parent.querySelector('[js-tab-content]')

            // required data
            const primaryImage = currentTarget.dataset.primaryImage
            const secondaryImage = currentTarget.dataset.secondaryImage
            const bgColor        = currentTarget.dataset.imgBgColor

            const isPrimaryImg = imageElm.querySelector('[js-primary-image]')
            const isSecondaryImg = imageElm.querySelector('[js-secondary-image]')
            if(isPrimaryImg && primaryImage) {
                isPrimaryImg.src  = primaryImage
            }
            if(isSecondaryImg && secondaryImage) {
                isSecondaryImg.src = secondaryImage
            }

            if(imageElm) {
                const tabImg = imageElm.querySelector('[js-tab-image]')
                tabImg ? tabImg.style.background = bgColor : ""
            }
            // remove active from all elements
            colorSwatchItems.forEach(clr => clr.classList.contains('active') ? clr.classList.remove('active') : "")
            // add active to current element
            !currentTarget.classList.contains('active') ? currentTarget.classList.add('active') : ""
            
        })
    })

})